module.exports = __webpack_public_path__ + "static/img/form-widget-min.65b8c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/form-widget-min.png
// module id = A7Rw
// module chunks = 0